import { useQuery } from "@apollo/client";
import AppSettings from "AppSettings";
import Button from "components/base/Button";
import Errors from "components/base/Errors";
import { Input } from "components/base/Form";
import { InlineSpinner } from "components/base/Spinner";
import { useModals } from "ModalProvider";
import { OdooContext } from "OdooProvider";
import { useContext } from "react";
import OdooProductFormLoader from "../odoo/OdooProductFormLoader";
import { FETCH_ODOO_PRODUCTS_FOR_VALIDATION } from "./graphql";
import { ProductContext } from "./ProductForm";
import ValidateOdooCompanyView from "./ValidateOdooCompanyView";

const OdooInfoView = () => {
  const { odooUrl, odooUrlInc } = useContext(OdooContext);
  const { id, product, setProduct } = useContext(ProductContext);

  const { loading, error, data } = useQuery(
    FETCH_ODOO_PRODUCTS_FOR_VALIDATION,
    {
      variables: {
        instance: "AB",
        ids: [product.odooId],
        fields: ["company_id"],
      },
      skip: !product.odooId,
    },
  );

  const odooProduct = data?.odooProducts
    ? JSON.parse(data.odooProducts)[0]
    : null;

  const companies = Object.entries(AppSettings.odooCompanies)
    .filter(([company, _]) =>
      product.company === "UNSET" ? true : company === product.company,
    )
    .map(([company, companyId]) => ({
      id: companyId,
      name: company,
    }));

  const syncModal = useModals();
  function syncHandler() {
    syncModal.present({
      title: "Create Product to AB Odoo",
      maxWidth: "max-w-6xl",
      children: (
        <OdooProductFormLoader
          id={id}
          onCreated={(product) => {
            setProduct((prev) => ({ ...prev, odooId: product.odooId }));
            syncModal.hide();
          }}
        />
      ),
    });
  }

  return (
    <div className="card">
      <h5 className="text-purple-500">Odoo Info</h5>
      <div className="mt-2 -mx-2">
        <table>
          <tbody>
            <tr>
              <td>
                <label>AB Variant ID: </label>
              </td>
              <td>
                <Input
                  className="w-full"
                  value={product.odooId}
                  onChange={(e) =>
                    setProduct((prev) => ({
                      ...prev,
                      odooId: e.target.value,
                    }))
                  }
                />
              </td>
            </tr>
            <tr>
              <td>
                <label>INC Variant ID: </label>
              </td>
              <td>
                <Input
                  className="w-full"
                  value={product.odooIdInc}
                  onChange={(e) =>
                    setProduct((prev) => ({
                      ...prev,
                      odooIdInc: e.target.value,
                    }))
                  }
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      {loading && <InlineSpinner size={16} />}
      {error && <Errors error={error} />}

      <div className="mt-2 space-y-4">
        {(product.odooId || product.odooIdInc) && (
          <div className="whitespace-normal flex items-center space-x-2 mt-2">
            {product.odooId &&
              companies.map((i) => (
                <div key={i.id}>
                  <a
                    href={`${odooUrl}/odoo/action-563/${product.odooId}?cids=${i.id}`}
                    target="_blank"
                    rel="noreferer"
                  >
                    Odoo {i.name}
                  </a>
                </div>
              ))}

            {product.odooIdInc && (
              <a
                href={`${odooUrlInc}/odoo/action-195/${product.odooIdInc}`}
                target="_blank"
                rel="noreferer"
              >
                Odoo INC
              </a>
            )}
          </div>
        )}

        {id && <Button onClick={syncHandler}>Sync Product to AB Odoo</Button>}

        {product.odooId && odooProduct && (
          <ValidateOdooCompanyView
            odooCompany={odooProduct.company_id}
            wisCompany={product.company}
          />
        )}
      </div>
    </div>
  );
};

export default OdooInfoView;
